var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDriverLicenceSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9935 16.9933H20.9928C21.5925 16.9933 21.9924 16.5934 21.9924 15.9936V12.9948C21.9924 12.0951 21.2927 11.2954 20.493 11.0955C18.6936 10.5957 15.9947 9.99593 15.9947 9.99593C15.9947 9.99593 14.6952 8.59646 13.7955 7.6968C13.2957 7.29696 12.6959 6.99707 11.9962 6.99707H4.99886C4.39909 6.99707 3.89928 7.39692 3.59939 7.89673L2.19992 10.7956C2.06755 11.1817 2 11.587 2 11.9952V15.9936C2 16.5934 2.39985 16.9933 2.99962 16.9933H4.99886",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99729 18.9926C8.10144 18.9926 8.99652 18.0975 8.99652 16.9934C8.99652 15.8892 8.10144 14.9941 6.99729 14.9941C5.89314 14.9941 4.99805 15.8892 4.99805 16.9934C4.99805 18.0975 5.89314 18.9926 6.99729 18.9926Z",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 16.9932H14.9938",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9934 18.9926C18.0975 18.9926 18.9926 18.0975 18.9926 16.9934C18.9926 15.8892 18.0975 14.9941 16.9934 14.9941C15.8892 14.9941 14.9941 15.8892 14.9941 16.9934C14.9941 18.0975 15.8892 18.9926 16.9934 18.9926Z",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriverLicenceSmall);
export default __webpack_public_path__ + "static/media/icon_driver_licence_small.5b8d2296eb0b5c2fe2c1af7a4d895dd6.svg";
export { ForwardRef as ReactComponent };